module.exports = __webpack_public_path__ + "img/Monitor.483b229c.svg";